import React,{useEffect,useRef,useState} from "react";
import Slider from "react-slick";
import {Image} from 'react-bootstrap'
import { Player } from 'video-react'; // Or any other player you're using
import "video-react/dist/video-react.css"; // Required if using video-react
import "./ImageSlider.css";
const images = [
  {
    url: "https://img500.exportersindia.com/product_images/bc-500/2023/1/3571043/deep-home-cleaning-services-1672811734-4054697.jpeg",
    title: "Deep Home Cleaning"
  },
  {
    url: "https://rukminim2.flixcart.com/image/850/1000/xif0q/bathroom-floor-cleaner/e/a/0/-original-imah2qcsderfmnch.jpeg?q=20&crop=false",
    title: "Bathroom Floor Cleaner"
  },
  {
    url: "https://maidforyounh.com/wp-content/uploads/2020/12/house-cleaning-services-1024x789.jpg",
    title: "House Cleaning Services"
  },
  {
    url: "https://m.media-amazon.com/images/I/81DIhhwDyTL.jpg",
    title: "Cleaning Supplies"
  },
  {
    url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRm0O4J6J47S5j65AMlBJN4qp8fj6MziZe_DqXCmtf0B0ssD9KzIbZp9I7CZXyF_vV6IGw&usqp=CAU",
    title: "Professional Cleaning Team"
  },
  {
    url: "https://m.media-amazon.com/images/I/81DIhhwDyTL.jpg",
    title: "Essential Tools"
  },
  {
    url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRm0O4J6J47S5j65AMlBJN4qp8fj6MziZe_DqXCmtf0B0ssD9KzIbZp9I7CZXyF_vV6IGw&usqp=CAU",
    title: "Expert Staff"
  }
];

export default function ImageSlider() {
    const [isOpen, setIsOpen] = useState(false);
  
    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);
   const [activeIndex, setActiveIndex] = useState(1);
  const sliderRef = useRef(null);

  const scrollToIndex = (index) => {
    const slider = sliderRef.current;
    const cardWidth = slider.offsetWidth / 3;
    slider.scrollTo({
      left: cardWidth * (index - 1),
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const handleScroll = () => {
    const slider = sliderRef.current;
    const cardWidth = slider.offsetWidth / 3;
    const index = Math.round(slider.scrollLeft / cardWidth) + 1;
    setActiveIndex(index);
  };

  // Initial scroll
  useEffect(() => {
    scrollToIndex(activeIndex);
  }, []);

  // Auto-slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % images.length;
        scrollToIndex(nextIndex === 0 ? 1 : nextIndex);
        return nextIndex === 0 ? 1 : nextIndex;
      });
    }, 5000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  
    return (
        <div className="slider-container-finest">
      <div className="slider" ref={sliderRef} onScroll={handleScroll}>
        {images.map((src, index) => (
          <div
            key={index}
            className={`card ${index === activeIndex ? "active" : "inactive"}`}
            onClick={openModal}
          >
           <Image src={src.url} className="imageSlider" />
              
              <div className="bottomShodow">
                <h5 className="title">{src.title}</h5>
              </div>
          
           
          </div>
        ))}
      </div>

      <div className="dots">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === activeIndex ? "active-dot" : ""}`}
            onClick={() => scrollToIndex(index)}
          />
        ))}
      </div>

          {/* Modal */}
            {isOpen && (
              <div style={styless.overlay}>
                <div style={styless.modal}>
                  <button onClick={closeModal} style={styless.closeButton}>✖</button><br></br><br></br>
      
                  <Player
                    autoPlay
                    muted
                    playsInline
                  
                    style={{width:"100%",height:250,marginTop:10,position:"relative"}}
                   
                  >
                    <source src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4" />
                  </Player>
                </div>
              </div>
            )}
    </div>
    );
  };

  const styless = {
  button: {
    fontSize: '18px',
    padding: '10px 20px',
    cursor: 'pointer'
  },
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  },
  modal: {
    backgroundColor: '#fff',
    width: '90%',
    maxWidth: '600px',
  
    padding: '10px',
    position: 'relative',
    borderRadius: '8px'
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    background: 'transparent',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer'
  }
};
